import { userService } from '../../services/UserService';

export function downloadTenantUserPhoto(
  userId: string,
): Promise<Blob | null | undefined> {
  return userService.downloadUserPhoto(userId);
}
